<template>

  <div class="container">

    <!--工具简介-->
    <div class="tools-intro" :style="{backgroundImage:'url('+require('../assets/banner-tools.png')+')'}" style=" background-size:100% 100%;">
      <div style="width: 1600px; align-items: center; margin: 0 auto; " >
        <el-image style="width: 100px; height: 100px; float: left" :src="require('@/assets/icon/json.svg')"></el-image>
        <div style="position: relative;  left: 40px">
          <p style="font-size: 25px; font-weight: 600">JSON代码格式化工具</p>
          <p>JSON格式化采用vue-json-viewer插件实现</p>

        </div>

      </div>


    </div>

    <div style="width:1600px; margin:40px auto">
      <h3>操作区</h3>
      <el-button @click="Format" type="primary">格式化代码</el-button>

    </div>

    <!--代码框-->
    <div style="width: 1600px;display: flex; justify-content: space-between;">

      <div style="width: 49%">
        <h3>待格式化JSON</h3>
        <el-input class="inputCode" v-model="nativeCode"
                  type="textarea"
                  :rows="20"></el-input>
      </div>

      <div style="width: 49%">
        <h3>格式化JSON</h3>
        <json-viewer :value="formatCode"
                     copyable style="min-height: 431px"
                     ></json-viewer>

      </div>
    </div>





  </div>
</template>

<script>


export default {
  name: "JsonTools",
  data(){
    return{
      nativeCode: '',
      formatCode:'',

    }
  },
  methods:{


    Format(){


      // this.formatCode = JSON.stringify((this.nativeCode),null,2);

      this.formatCode = JSON.parse(this.nativeCode)
      console.log(typeof this.formatCode)
    },





  }
}
</script>

<style scoped>
.container{
  text-align: left;
  display: flex;
  flex-direction: column;
  /*justify-content: center;    !* 垂直居中 *!*/
  align-items: center;        /* 水平居中 */
  background: #FAFCFF;
  height: 100%;
}


.tools-intro{

  width: 100%;
  height: 200px;
  box-shadow: 0px 0px 40px 0px rgb(217, 224, 234);


}



/deep/ .el-textarea__inner {
  font-family: sans-serif !important;

}

/deep/.el-button.el-button--primary{
  background:#4154F1
}

/deep/.el-button.el-button--success{
  background:#28bd6c
}



</style>
